import { useCallback, useEffect, useState } from "react";
import type { EmblaOptionsType, EmblaPluginType } from "embla-carousel-react";
import useEmblaCarousel from "embla-carousel-react";

export const useCarousel = (
  options?: EmblaOptionsType,
  plugin?: EmblaPluginType[],
  draggable: Boolean = true
) => {
  const [emblaRef, embla] = useEmblaCarousel(options, plugin);
  const [prevBtnEnabled, setPrevBtnEnabled] = useState(false);
  const [nextBtnEnabled, setNextBtnEnabled] = useState(false);
  const scrollPrev = useCallback(() => embla && embla.scrollPrev(), [embla]);
  const scrollNext = useCallback(() => embla && embla.scrollNext(), [embla]);
  const [scrollSnaps, setScrollSnaps] = useState<number[]>([]);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const scrollTo = useCallback(
    (index: number) => embla && embla.scrollTo(index),
    [embla]
  );

  const onSelect = useCallback(() => {
    if (!embla) return;
    setSelectedIndex(embla.selectedScrollSnap());
    setPrevBtnEnabled(embla.canScrollPrev());
    setNextBtnEnabled(embla.canScrollNext());
  }, [embla, setSelectedIndex]);
  useEffect(() => {
    if (!embla || !draggable) return;
    onSelect();
    setScrollSnaps(embla.scrollSnapList());
    embla.on("select", onSelect);
    embla.on("reInit", () => {
      onSelect();
      setScrollSnaps(embla.scrollSnapList());
    });
  }, [embla, onSelect, draggable]);
  return {
    embla,
    emblaRef,
    scrollSnaps,
    selectedIndex,
    scrollTo,
    scrollNext,
    scrollPrev,
    prevBtnEnabled,
    nextBtnEnabled,
  };
};
